<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md5 lg4 xl3>
        <div class="form-header py-5">
          <!-- <v-img
            class="mx-auto logo-image mb-2"
            :src="require('@/assets/logo.png')"
            max-width="200"
            contain
          ></v-img> -->
          <v-img
            class="mx-auto logo-image mb-2"
            :src="require('@/assets/Belit-logo.png')"
            max-width="200"
            contain
          ></v-img>
          <!-- <h5 style="font-weight: normal">
            <b>E</b>nergy <b>P</b>erformance and <b>SMA</b>rt <b>R</b>eadiness
            <b>C</b>ertification Tool v0.9
          </h5> -->

          <h2 class="login-label mt-6">Sign in to your account</h2>
        </div>

        <v-card class="px-5 py-3" elevation="1">
          <v-form ref="form" @submit.prevent="login">
            <v-card-text>
              <v-text-field
                prepend-icon="person"
                name="email"
                label="Email"
                type="text"
                color="indigo"
                v-model="email"
                :rules="[required, emailValid]"
              ></v-text-field>
              <v-text-field
                id="password"
                prepend-icon="lock"
                name="password"
                label="Password"
                type="password"
                color="indigo"
                v-model="password"
                :rules="[required, passwordLength]"
              ></v-text-field>

              <div style="display: flex; justify-content: space-between">
                <div>
                  <v-checkbox
                    color="indigo"
                    v-model="rememberMe"
                    label="Remember me"
                  ></v-checkbox>
                </div>
                <div style="display: flex; align-items: center">
                  <a
                    style="color: #4d51c5"
                    @click="openPasswordAssistanceDialog"
                    >Forgot password?</a
                  >
                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                type="submit"
                class="white--text"
                color="#4d51c5"
                rounded
                width="100%"
                >SIGN IN</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card>
        <div style="border: 1px solid transparent; height: 100px">
          <v-alert
            class="mt-4"
            v-model="alert"
            type="error"
            elevation="2"
            dismissible
          >
            User account not found
          </v-alert>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import services from "../rest/Services";
import router from "../router/index.js";

export default {
  name: "Login",
  props: {
    source: String,
  },
  data: () => ({
    rememberMe: false,
    alert: false,
    email: "",
    password: "",
    required: (value) => !!value || "Required.",
    emailValid: (value) => {
      const pattern =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return pattern.test(value) || "Invalid e-mail.";
    },
    passwordLength: (value) => {
      return (
        (value && value.length >= 8) ||
        "Password must be at least 6 characters long"
      );
    },
  }),
  methods: {
    login: function () {
      if (this.$refs.form.validate()) {
        services
          .login({
            email: this.email,
            password: this.password,
          })
          .then((response) => {
            localStorage.setItem("jwt", response.data.jwt);
            response.data.account.email = this.email;
            sessionStorage.setItem(
              "account",
              JSON.stringify(response.data.account)
            );
            this.$refs.form.reset();
            router.push("/dashboard");
          })
          .catch((error) => {
            console.log(error);
            this.alert = true;
          });
      }
    },
    openPasswordAssistanceDialog: function () {
      this.$emit("openPasswordAssistanceDialog");
    },
  },
};
</script>

<style>
.form-header {
  text-align: center;
}
.login-label {
  font-family: system-ui, "Segoe UI", Roboto, Helvetica, Arial, sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-weight: bold;
}
</style>
